/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UsersBrowserRegistration} from '../models/UsersBrowserRegistration';
import type {UsersBrowserRegistrationResponse} from '../models/UsersBrowserRegistrationResponse';

export interface GetBrowserRegistrationJobProgress$Request {
    id: string;
}

export interface GetBrowserRegistrationJobProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getBrowserRegistrationJobProgressRequest = createAction<PayloadData<void, GetBrowserRegistrationJobProgress$Request>>('BULK_USERS_BROWSER_REGISTRATION__GET_BROWSER_REGISTRATION_JOB_PROGRESS__REQUEST');
export const getBrowserRegistrationJobProgressSuccess = createAction<PayloadData<BulkProgress, GetBrowserRegistrationJobProgress$Request>>('BULK_USERS_BROWSER_REGISTRATION__GET_BROWSER_REGISTRATION_JOB_PROGRESS__SUCCESS');
export const getBrowserRegistrationJobProgressFailure = createAction<PayloadData<Error, GetBrowserRegistrationJobProgress$Request, true>>('BULK_USERS_BROWSER_REGISTRATION__GET_BROWSER_REGISTRATION_JOB_PROGRESS__FAILURE');

export const getBrowserRegistrationJobProgressActions = [
    getBrowserRegistrationJobProgressRequest,
    getBrowserRegistrationJobProgressSuccess,
    getBrowserRegistrationJobProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getBrowserRegistrationJobProgress = (meta: GetBrowserRegistrationJobProgress$Request, config?: GetBrowserRegistrationJobProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getBrowserRegistrationJobProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/browsers-registration/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetBrowserRegistrationResult$Request {
    id: string;
}

export interface GetBrowserRegistrationResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getBrowserRegistrationResultRequest = createAction<PayloadData<void, GetBrowserRegistrationResult$Request>>('BULK_USERS_BROWSER_REGISTRATION__GET_BROWSER_REGISTRATION_RESULT__REQUEST');
export const getBrowserRegistrationResultSuccess = createAction<PayloadData<UsersBrowserRegistrationResponse, GetBrowserRegistrationResult$Request>>('BULK_USERS_BROWSER_REGISTRATION__GET_BROWSER_REGISTRATION_RESULT__SUCCESS');
export const getBrowserRegistrationResultFailure = createAction<PayloadData<Error, GetBrowserRegistrationResult$Request, true>>('BULK_USERS_BROWSER_REGISTRATION__GET_BROWSER_REGISTRATION_RESULT__FAILURE');

export const getBrowserRegistrationResultActions = [
    getBrowserRegistrationResultRequest,
    getBrowserRegistrationResultSuccess,
    getBrowserRegistrationResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getBrowserRegistrationResult = (meta: GetBrowserRegistrationResult$Request, config?: GetBrowserRegistrationResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getBrowserRegistrationResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/bulk-actions/users/browsers-registration`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface StopBrowserRegistration$Request {
    id: string;
}

export interface StopBrowserRegistration$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const stopBrowserRegistrationRequest = createAction<PayloadData<void, StopBrowserRegistration$Request>>('BULK_USERS_BROWSER_REGISTRATION__STOP_BROWSER_REGISTRATION__REQUEST');
export const stopBrowserRegistrationSuccess = createAction<PayloadData<void, StopBrowserRegistration$Request>>('BULK_USERS_BROWSER_REGISTRATION__STOP_BROWSER_REGISTRATION__SUCCESS');
export const stopBrowserRegistrationFailure = createAction<PayloadData<Error, StopBrowserRegistration$Request, true>>('BULK_USERS_BROWSER_REGISTRATION__STOP_BROWSER_REGISTRATION__FAILURE');

export const stopBrowserRegistrationActions = [
    stopBrowserRegistrationRequest,
    stopBrowserRegistrationSuccess,
    stopBrowserRegistrationFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const stopBrowserRegistration = (meta: StopBrowserRegistration$Request, config?: StopBrowserRegistration$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: stopBrowserRegistrationActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/bulk-actions/users/browsers-registration`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateUsersBrowserRegistration$Request {
    usersBrowserRegistration: UsersBrowserRegistration;
    reason?: string;
}

export interface UpdateUsersBrowserRegistration$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateUsersBrowserRegistrationRequest = createAction<PayloadData<void, UpdateUsersBrowserRegistration$Request>>('BULK_USERS_BROWSER_REGISTRATION__UPDATE_USERS_BROWSER_REGISTRATION__REQUEST');
export const updateUsersBrowserRegistrationSuccess = createAction<PayloadData<string, UpdateUsersBrowserRegistration$Request>>('BULK_USERS_BROWSER_REGISTRATION__UPDATE_USERS_BROWSER_REGISTRATION__SUCCESS');
export const updateUsersBrowserRegistrationFailure = createAction<PayloadData<Error, UpdateUsersBrowserRegistration$Request, true>>('BULK_USERS_BROWSER_REGISTRATION__UPDATE_USERS_BROWSER_REGISTRATION__FAILURE');

export const updateUsersBrowserRegistrationActions = [
    updateUsersBrowserRegistrationRequest,
    updateUsersBrowserRegistrationSuccess,
    updateUsersBrowserRegistrationFailure
] as const;

/**
 * @param {UsersBrowserRegistration} meta.usersBrowserRegistration
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateUsersBrowserRegistration = (meta: UpdateUsersBrowserRegistration$Request, config?: UpdateUsersBrowserRegistration$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: updateUsersBrowserRegistrationActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/bulk-actions/users/browsers-registration`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.usersBrowserRegistration,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

